import { EDITHOLIDAY_SUCCESS, EDITHOLIDAY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const EditHolidayReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDITHOLIDAY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case EDITHOLIDAY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default EditHolidayReducer;
